import { AUTO_GRANTED_SKILL_IDS, isLockedSkill } from './utils';

const calculatedFields = new Set([
    'bodyPoints', 'maxArmor', 'dexArmor', 'agilityPoints', 'arcanePoints',
    'naturePoints', 'spiritPoints', 'staminaPoints', 'thaumaturgyPoints',
    'skillPointsSpent', 'skillPointsUnspent',
]);

// Object property order and skill display/cost annotations are not edits.
const stable = value => {
    if (Array.isArray(value)) return value.map(stable);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.keys(value).sort().map(key => [key, stable(value[key])]));
    }
    return value;
};

export default function characterSaveSignature(character, catalog = []) {
    if (!character) return null;
    const byId = new Map(catalog.map(skill => [Number(skill.skillId), skill]));
    const editable = Object.fromEntries(Object.entries(character).filter(([key]) => !calculatedFields.has(key)));
    editable.skills = (character.skills || [])
        .filter(skill => !AUTO_GRANTED_SKILL_IDS.includes(Number(skill.skillId)) && !isLockedSkill(byId.get(Number(skill.skillId))))
        .map(skill => ({ skillId: Number(skill.skillId), ranks: Number(skill.ranks) }))
        .sort((a, b) => a.skillId - b.skillId);
    return JSON.stringify(stable(editable));
}
